import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { formatCurrency } from "@/lib/api";
import OrderProgressSection from "./OrderProgressSection";
import OrderWorkersSection from "./OrderWorkersSection";

/**
 * Dialog standalone pour saisir l'avancement CA d'une commande depuis la
 * liste des commandes (accès rapide via bouton icône Calculator).
 */
export const OrderProgressDialog = ({ order, onClose, onChange }) => {
  return (
    <Dialog open={!!order} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="order-progress-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">
            Avancement CA — {order?.reference}
          </DialogTitle>
          <DialogDescription>
            {order?.client_name} — Montant HT {" "}
            <strong className="currency">{formatCurrency(order?.amount_ht || 0)}</strong>
          </DialogDescription>
        </DialogHeader>
        {order && (
          <div className="space-y-4">
            <OrderProgressSection order={order} onChange={onChange} />
            <OrderWorkersSection orderId={order.id} />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OrderProgressDialog;
